import React, { useEffect, useState } from "react";
import { useLazyCategorylistQuery, useLazyCartViewQuery, useDeleteFromCartMutation, useWhishlistMutation, useLazyViewWishlistQuery, useLazyViewProductsQuery, useAddToCartMutation } from "../../redux/Api/api";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { FaHeart } from 'react-icons/fa';
import { toast, ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { saveCartCountHandler } from "../../redux/reducer/CartCountSlice";
import { saveWishlistCountHandler } from "../../redux/reducer/WhislistCountSlice";

const AquaPage = () => {
    const [price, setPrice] = useState(1000);
    const [cartItems, setCartItems] = useState([]);
    const [quantity, setQuantity] = useState(1);
    const [selectedBrands, setSelectedBrands] = useState([]);
    const [showSuccessPopup, setShowSuccessPopup] = useState(false);
    const [selectedFilterCategories, setSelectedFilterCategories] = useState([]);
    const [products, setProducts] = useState([]);
    const [showAddToCartPopup, setShowAddToCartPopup] = useState(false);
    const [addedProduct, setAddedProduct] = useState(null);
    const [categories, setCategories] = useState([]);
    const [fetchwhislist] = useWhishlistMutation();
    const [brands, setBrands] = useState([]);
    const [error, setError] = useState(null);
    const [productName, setProductName] = useState("");
    const dispatch = useDispatch();
    const [deleteFromCart] = useDeleteFromCartMutation();
    const [wishlistStatus, setWishlistStatus] = useState({});
    const [getProductList] = useLazyViewProductsQuery();
    const [addToCart] = useAddToCartMutation();
    const [whishlist] = useLazyViewWishlistQuery();
    const [getcategory] = useLazyCategorylistQuery();
    const [selectedCategories, setSelectedCategories] = useState([]);
    const location = useLocation();
    const navigate = useNavigate();
    const routeData = location?.state?.data;
    const category = location?.state?.category || "aqua";
    const [cartlist] = useLazyCartViewQuery();
    const [setShowRemovePopup] = useState(null);

    const handleRemove = (item) => {
        const cartItemId = item._id;
        if (!cartItemId) {
            toast.error("Unable to remove item.");
            return;
        }
        deleteFromCart(cartItemId)
            .unwrap()
            .then(() => {
                getcartlist()
                setCartItems((prevItems) => prevItems.filter((cartItem) => cartItem._id !== cartItemId));
                toast.success("Item removed successfully.");
            })
            .catch((err) => {
                console.error("Error removing item from cart:", err);
                toast.error("Error removing item from cart.");
            });
    };

    useEffect(() => {
        const storedWishlist = JSON.parse(localStorage.getItem("wishlist")) || {};
        setWishlistStatus(storedWishlist);
    }, []);


    const fetchCategories = () => {
        getcategory()
            .unwrap()
            .then((res) => {
                setCategories(res?.data);
            })
            .catch((err) => {
                console.error("Error fetching categories:", err);
            });
    };

    const handleWishlist = (item) => {
        const user = JSON.parse(localStorage.getItem('user'));
        if (!user || !user._id) {
            toast.error("Please log in first.");
            return;
        }
        const userId = user._id;
        const productId = item._id;
        if (!userId || !productId) {
            toast.error("Invalid user or product.");
            return;
        }

        setWishlistStatus((prevStatus) => {
            const updatedStatus = {
                ...prevStatus,
                [item._id]: !prevStatus[item._id],
            };
            localStorage.setItem("wishlist", JSON.stringify(updatedStatus)); // Save instantly
            return updatedStatus;
        });
        fetchwhislist({ userId, productId })
            .unwrap()
            .then((res) => {
                console.log("Wishlist Update Response:", res);
                const storedUser = JSON.parse(localStorage.getItem('user'));
                const id = storedUser?._id
                whishlist({ userId: user._id }).unwrap().then(res => {
                    console.log('Ress', res);
                    if (res?.status == "success") {
                        const data = res?.data
                        dispatch(saveWishlistCountHandler(data?.length))
                        toast.success('wishlist added successfully');
                    }
                }).catch(err => {
                    console.log('Err', err);

                })
            })
            .catch((err) => {
                console.error("Error updating wishlist:", err);
                toast.error(err?.data?.message || "Unable to add product to wishlist.");
            });
    };

    const handleQuantityChange = (newQuantity) => {
        if (newQuantity > 0) {
            setQuantity(newQuantity);
        }
    };

    const getcartlist = () => {
        const storedUser = JSON.parse(localStorage.getItem('user'));
        console.log('storedUser', storedUser);
        const id = storedUser?._id
        cartlist(id).unwrap().then(res => {
            console.log('CartRess', res);
            dispatch(saveCartCountHandler(res?.length))
        }).catch(err => {
            console.log('Err', err);
        })
    };

    const handleCloseSuccessPopup = () => {
        setShowSuccessPopup(false);
    };
    const handleConfirmAddToCart = () => {
        setShowAddToCartPopup(false);
        setShowSuccessPopup(true);
    };

    const handleClosePopup = () => {
        setShowAddToCartPopup(false);
    };

    const fetchProducts = () => {
        getProductList()
            .unwrap()
            .then((res) => {
                const aquaProducts = res?.products?.filter((product) => product?.categorytype === "aqua");
                setProducts(aquaProducts);

                const uniqueBrands = [...new Set(res?.products.map((product) => product.brand))];
                setBrands(uniqueBrands);

                console.log("aquaProducts", aquaProducts, res?.products);
                setProductName(res?.product?.name);
            })
            .catch((err) => {
                setError("Error fetching products");
                console.error("Fetch error:", err);
            });
    };
    const confirmRemove = (item) => {
        handleRemove(item);
        setShowRemovePopup(null);
    };

    const handleAddToCart = (item) => {
        const productId = item?._id;
        const user = JSON.parse(localStorage.getItem('user'));

        if (!user || !user._id) {
            toast.error("Please log in first.");
            return;
        }

        const userId = user._id;
        console.log("Product ID:", productId);
        console.log("User ID:", userId);

        addToCart({ productId: item._id, userId })
            .unwrap()
            .then((res) => {
                cartlist(userId).unwrap().then(cartRes => {
                    dispatch(saveCartCountHandler(cartRes?.length));

                });
                toast.success("Product added to cart successfully!");
                setAddedProduct(item);
                setShowAddToCartPopup(true);
            })
            .catch((err) => {
                console.error("Error adding to cart:", err);
                toast.error(err?.data?.message || "Unable to add product to cart.");
            });
    };

    const handleCategoryChange = (category) => {
        setSelectedCategories((prevSelectedCategories) =>
            prevSelectedCategories.includes(category)
                ? prevSelectedCategories.filter((c) => c !== category)
                : [...prevSelectedCategories, category]
        );
    };
    const handlePriceChange = (e) => setPrice(e.target.value);
    const handleBrandChange = (brand) => {
        setSelectedBrands((prev) =>
            prev.includes(brand) ? prev.filter((b) => b !== brand) : [...prev, brand]
        );
    };
    const filteredProducts = products.filter((product) => {
        const priceMatch = product.price <= price;
        const brandMatch = selectedBrands.length === 0 || selectedBrands.includes(product.brand);
        const categoryMatch =
            selectedFilterCategories.length === 0 || selectedFilterCategories.includes(product.category);
        return priceMatch && brandMatch && categoryMatch;
    });

    const convertToPaise = (amount) => Math.round(amount * 100);
    const paymentFun = () => {
        if (!window.Razorpay) {
            console.error('Razorpay SDK is not loaded');
            return;
        }
        const options = {
            key: 'rzp_test_2ZQgDDm96U20lT',
            amount: convertToPaise(totalPrice + 50),
            currency: 'INR',
            name: 'SaiAquapets',
            description: 'Payment for test order',
            prefill: {
                email: 'info@saiaquapets@gmail.com',
                contact: '+91 63838 89291',
                name: "Harish Kumar Narayanaswamy",
            },
            theme: { color: '#1106AC' },
        };
        const rzp = new window.Razorpay(options);
        rzp.on('payment.success', (response) => {
            toast.success('Payment Success!');
            console.log('Success Data:', response);
            navigate('home');
        });
        rzp.on('payment.error', (error) => {
            toast.error('Payment Failed!');
            console.error('Error Data:', error);
        });
        rzp.open();
    };
    const totalPrice = cartItems.reduce((acc, item) => {
        const price = item.product.price || 0;
        const quantity = item.product.quantity || 1;
        return acc + price * quantity;
    }, 0);

    useEffect(() => {
        fetchCategories();
        fetchProducts();
    }, [category]);

    return (
        <div className="flex flex-col lg:flex-row mt-[60px] mb-[60px] px-4 lg:px-10">
            <div className="lg:w-1/4 w-full lg:sticky top-0 bg-gray-100 p-4 rounded-lg mb-6 lg:mb-0">
                <h2 className="text-xl font-bold mb-9">Filter By</h2>

                <div className="mb-8">
                    <h3 className="text-xl font-semibold mb-4">Brand</h3>
                    <ul>
                        {brands.map((brand) => (
                            <li key={brand}>
                                <label>
                                    <input
                                        type="checkbox"
                                        className="mr-2 mb-3"
                                        checked={selectedBrands.includes(brand)}
                                        onChange={() => handleBrandChange(brand)}
                                    />
                                    {brand}
                                </label>
                            </li>
                        ))}
                    </ul>
                </div>

                {/* Price Filter */}
                <div className="mb-6">
                    <h3 className="text-xl font-semibold mb-4">Price</h3>
                    <input
                        type="range"
                        min="0"
                        max="20000"
                        value={price}
                        onChange={handlePriceChange}
                        className="w-full"
                    />
                    <p className="mt-4">Price: Rs {price}</p>
                </div>

                <div className="mb-6">

                    <h3 className="text-xl font-semibold mb-4">Category</h3>
                    <ul>
                        {categories.map((category) => (
                            <li key={category._id}>
                                <label>
                                    <input
                                        type="checkbox"
                                        className="mr-2 mb-4"
                                        checked={selectedCategories.includes(category.category_name)}
                                        onChange={() => handleCategoryChange(category.category_name)}
                                    />
                                    {category.category_name}
                                </label>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-6 md:p-8 md:mb-auto">
                {filteredProducts.length > 0 ? (
                    filteredProducts.map((product) => (
                        <div key={product._id} className="p-10 text-center rounded-lg border shadow-lg relative">
                            <a onClick={() => navigate('/productview', { state: product })}>
                                <div className="relative">
                                    <img
                                        src={product.image || "/assets/default_product_image.png"}
                                        alt={product.name || "Product image"}
                                        className="w-full h-48 object-contain mb-4" />
                                </div></a>
                            <button
                                className={`absolute top-2 right-2 cursor-pointer text-2xl 
                                  ${wishlistStatus[product._id] ? "text-red-600" : "text-gray-400"} 
                  p-2 bg-white hover:text-red-600 hover:bg-gray-200`}
                                onClick={() => handleWishlist(product)}>
                                <FaHeart />
                            </button>
                            <h3 className="font-semibold">{product.name}</h3>
                            <p className="text-sm mt-2 text-gray-700">{product.description}</p>
                            <p className="text-lg font-semibold mt-2">Rs {product.price}</p>
                            <div className="flex justify-center mt-2">
                                <button
                                    className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-500"
                                    onClick={paymentFun}>
                                    Buy Now
                                </button>
                                <button
                                    className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-500 ml-2"
                                    onClick={() => handleAddToCart(product)}>
                                    Add to Cart
                                </button>
                            </div>
                        </div>
                    ))
                ) : (
                    <p>No products match your filters.</p>
                )}
            </div>
            {showAddToCartPopup && addedProduct && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
                    <div className="bg-white p-10 shadow-lg w-[700px] min-h-[330px] flex relative rounded-lg">
                        <button
                            className="absolute top-4 right-4 text-gray-600 hover:text-gray-900 text-2xl"
                            onClick={handleClosePopup}
                        >
                            <i className="fas fa-times"></i>
                        </button>

                        <div className="w-1/3 flex justify-center items-center">
                            <img
                                src={addedProduct.image}
                                alt={addedProduct.name}
                                className="w-64 h-64 rounded-lg border"
                            />
                        </div>
                        <div className="w-2/3 pl-20 flex flex-col justify-between">
                            <p className="text-3xl font-bold text-gray-900 mt-2 pr-96">{addedProduct.name}</p>
                            <div className="grid grid-cols-2 gap-2 items-center">
                                <p className="text-lg font-medium text-gray-700 text-left">Price:</p>
                                <p className="text-xl font-semibold text-green-600 pr-52">₹{addedProduct.price}</p>
                                <p className="text-lg font-medium text-gray-700 text-left">Quantity:</p>
                                <div className="flex items-center border rounded-lg w-fit">
                                    <button
                                        className="bg-gray-200 px-4 py-1 rounded-l text-base"
                                        onClick={() => handleQuantityChange(quantity - 1)}
                                    >
                                        -
                                    </button>
                                    <p className="px-3 text-lg">{quantity}</p>
                                    <button
                                        className="bg-gray-200 px-4 py-1 rounded-r text-base"
                                        onClick={() => handleQuantityChange(quantity + 1)}
                                    >
                                        +
                                    </button>
                                </div>
                                <p className="text-lg font-medium text-gray-700 text-left">Total Price:</p>
                                <p className="text-2xl font-semibold text-green-600 pr-56">
                                    ₹{addedProduct.price * quantity}
                                </p>
                            </div>
                            <div className="flex mt-4">

                                <button
                                    className="bg-blue-600 text-white px-4 py-2 text-lg font-semibold w-1/2 hover:bg-blue-700 flex items-center justify-center gap-2 rounded"
                                    onClick={handleConfirmAddToCart}
                                >
                                    <i className="fas fa-shopping-cart"></i> Add to Cart
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {showSuccessPopup && addedProduct && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
                    <div className="bg-white p-6 shadow-lg w-[600px] min-h-[350px] flex relative rounded-lg">
                        <button
                            className="absolute top-4 right-4 text-gray-600 hover:text-gray-900 text-2xl"
                            onClick={handleCloseSuccessPopup}>
                            <i className="fas fa-times"></i>
                        </button>
                        <div className="w-full flex flex-col items-center text-center p-4">
                            <i className="fas fa-shopping-cart text-green-500 text-3xl"></i>
                            <p className="text-xl font-bold text-green-600 mt-2">Item added to your cart!</p>
                            <div className="flex items-center gap-4 mt-4">
                                <img
                                    src={addedProduct.image}
                                    alt={addedProduct.name}
                                    className="w-20 h-20 rounded-lg border"
                                />
                                <div className="text-left flex items-center gap-2">
                                    <label className="text-lg font-medium text-gray-700">Price:</label>
                                    <p className="text-xl font-semibold text-green-600">₹{addedProduct.price}</p>
                                </div>
                            </div>

                            <p className="text-lg font-medium text-gray-700 mt-4">Frequently Bought Together</p>
                            <div className="flex gap-4 mt-6 w-full">
                                <button
                                    className="bg-teal-600 text-white px-4 py-2 text-lg font-semibold flex-grow hover:bg-teal-700"
                                    onClick={handleCloseSuccessPopup}>
                                    Back to Shopping
                                </button>
                                <button
                                    className="bg-blue-600 text-white px-4 py-2 text-lg font-semibold flex-grow hover:bg-blue-700"
                                    onClick={() => navigate('/cart')}
                                >
                                    Proceed to Checkout
                                </button>
                            </div>
                        </div>
                    </div>
                    <ToastContainer />

                </div>
            )}
        </div >
    );
}
export default AquaPage;